/**
 * Entry point. `install-globals` MUST be imported first so the `Buffer` global
 * the frozen @fume/core expects exists before any core code executes.
 *
 * StrictMode is intentionally omitted: its dev-only double-invoke would build
 * and immediately destroy a throwaway container pair, which muddies this
 * security demo. Production builds never double-invoke regardless.
 */
import './shims/install-globals.js';
import './styles.css';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';

const root = document.getElementById('root');
if (!root) {
  throw new Error('missing #root element');
}
createRoot(root).render(<App />);
